























































































































































/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FormHtmlEditor from '@/components/shared/FormHtmlEditor.vue';
import FormNumberInput from '@/components/shared/FormNumberInput.vue';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import LayerConfig from '@/models/map-context/LayerConfig';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

@Component({
  props: {
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
    FormNumberInput,
    FormHtmlEditor
  },
})
export default class SingleLayerAttributeInfos extends BaseComponent {
  layer!: LayerConfig;

  errorTxt: string | null = null;

  selectAll = false;

  guessMode = false;

  public attributeTypes = [{ value: 'xsd:int', label: 'Entier' },
    { value: 'xsd:string', label: 'Texte' },
    { value: 'xsd:date', label: 'Date' },
    { value: 'xsd:number', label: 'Nombre' },
    { value: 'xsd:boolean', label: 'Booléen' },
    { value: 'xsd:double', label: 'Double' },
    { value: 'gml:Point', label: 'Point' },
    { value: 'gml:Geometry', label: 'Geometrie' },
    { value: 'gml:Line', label: 'Ligne' },
    { value: 'gml:Polygon', label: 'Polygone' },
  ];

  editorLoaded = false;

  properties:any=[];

  newKey: string = "";

  newValue: string = "";

  listItems: any = [];

  showListModal = false;

  selectedField: any | null = null;

public widgetTypes = [
    { value: 'TextForm', label: 'Input texte' },
    { value: 'ListForm', label: 'Input Liste' },
    { value: 'NumberForm', label: 'Input nombre' },
    { value: 'Checkbox', label: 'Case à cocher' },
    //{ value: 'fileUpload', label: 'FileUpload' },
  ];


  mounted() {
    if (this.layer.layerProperties.length === 0 && this.layer.isVector()) {
      // No properties, try to guess from datas
      this.guessMode = true;
      const features = this.layer.getLayerSource().getFeatures();
      console.log(features[0]);
      if (features && features.length > 0) {
        if (this.is3DView()) {
          features[0].properties.propertyNames.forEach((element: any) => {
            this.layer.layerProperties.push(new LayerAttribute({
              name: element,
              type: 'xsd:string',
              widgetType: 'TextForm',
              editable: true,
              display: true,
            }));
          });
        } else {
          features[0].getKeys().forEach((element: any) => {
            this.layer.layerProperties.push(new LayerAttribute({
              name: element,
              type: 'xsd:string',
              widgetType: 'TextForm',
              editable: true,
              display: true,
            }));
          });
        }
      }
    }
    this.properties=this.layer.layerProperties;
    if (this.layer.ficheInfos.active) {
      this.editorLoaded = true;
    }
  }


  onChangeFicheInfoType() {
    if (this.layer.ficheInfos.active && (this.layer.ficheInfos.content === '' || this.layer.ficheInfos.content === undefined)) {
      this.initFicheContent();
    }
    this.editorLoaded = true;
  }

  initFicheContent() {
    this.layer.ficheInfos.content = '';
    if (this.layer.layerProperties) {
      for (let i = 0; i < this.layer.layerProperties.length; i += 1) {
        this.layer.ficheInfos.content += `<p>${this.layer.layerProperties[i].name}:{${this.layer.layerProperties[i].name}}</p>`;
      }
    }
  }

  isAttributeEditable() {
    return (this.layer.editable || this.guessMode) && this.contextService.isEditionActive;
  }

  getFieldType(value: string) {
    if (value.indexOf('xsd:') >= 0) {
      return value.split(':')[1];
    }
    return value;
  }

  openListModal(field: any) {
    this.selectedField = field;
    this.listItems = this.selectedField.widgetConfig ? [...this.selectedField.widgetConfig] : [];
    this.showListModal = true;
  }

  addKeyValue(field: any) {
    if (!field.widgetConfig || field.widgetConfig.length <=0) {
      field.widgetConfig = [];
    }
    field.widgetConfig.push({ value: this.newValue });
    this.newValue = '';
    this.listItems = field.widgetConfig;
  }

  addDistinctValues(field: any) {
    if (!field.widgetConfig || field.widgetConfig.length <=0) {
      field.widgetConfig = [];
    }
    field.widgetConfig.push({ value: ''});
    const size = /** @type {ol.Size} */ (this.getOpenLayersMapService().map.getSize());
    const extent = this.getOpenLayersMapService().map.getView().calculateExtent(size);
    this.layer.getDistinctValues(field,extent).subscribe((values) => {
      this.errorTxt += `${values.length} valeurs distinctes trouvées...`;
      //CHECK IF NUMBER and sort if number
      if(values.find((x:any)=>isNaN(x))==undefined){//aucune valeur n'est pas un nombre
        const asc = (arr:any) => arr.sort((a:any, b:any) => Number(a) - Number(b));
        values=asc(values);
        
      }
      values.forEach((element:any) => {
        if(!field.widgetConfig.find((x:any)=>x.value==element)){
          field.widgetConfig.push({ value: element });
        }
      });
    });

    this.newValue = '';
    this.listItems = field.widgetConfig;
  }

  onChangeType(field: LayerAttribute) {
    this.getWidgetType(field)
  } 

  getWidgetType(field: LayerAttribute){
    if(field.isText()){
      field.widgetType = 'TextForm'
    } else if(field.isBoolean()){
      field.widgetType = 'Checkbox'
    } else if(field.isNumber()){
      field.widgetType = 'NumberForm'
    }else if(field.isDate()){
      field.widgetType = 'TextForm'
    }else if(field.isGeometry()){
      field.widgetType = ''
    }
  }

  removeListItem(index: any) {
    if (this.selectedField) {
      this.listItems.splice(index, 1);
      // Mettre à jour widgetConfig
      this.selectedField.widgetConfig = this.listItems;
    }

  }
  widgetTypesForFieldType(field: any) {
    if (field.isText()) {
      return this.widgetTypes.filter(widget => ['TextForm', 'ListForm','fileUpload'].includes(widget.value));
    } else {
      return this.widgetTypes;
    }
  }
  reloadAttributes() {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm('Etes-vous sur de vouloir rechargez la définition des attributs depuis le serveur?')) {
      this.getMapService().setAttributeDefinition(this.layer, true);
      setTimeout(()=>{
        this.properties=this.layer.layerProperties;
        },3000);
    }
  }

  addAttribute() {
    this.layer.layerProperties.push(new LayerAttribute({
      name: `nouveau_${this.layer.layerProperties.length}`,
      type: 'xsd:string',
      widgetType: 'TextForm',
      editable: true,
      display: true,
    }));
    this.properties=this.layer.layerProperties;
  }
}
